<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'aulasEletivos',
                  params: { gestaoDeEletivosId: $route.params.gestaoDeEletivosId },
                })
            "
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Aula
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <!-- {{ gestaoDeAulaEletiva }} -->
      <v-col cols="12" v-if="gestaoDeAulaEletiva">
        <v-card color="primary" class="mb-5" outlined>
          <v-card-text>
            <!-- <h4>Turma: {{ gestaoDeAula.turma.descricao }}</h4> -->
            <h4>Disciplina: {{ gestaoDeAulaEletiva.disciplina.descricao }}</h4>
            <h4>
              Professor:
              {{
                gestaoDeAulaEletiva.professor
                  ? gestaoDeAulaEletiva.professor.nome
                  : "[NÃO INFORMADO]"
              }}
            </h4>
            <!-- <h4>
              Turno:
              {{
                gestaoDeAula.turma.turno ? gestaoDeAulaEletiva.turma.turno.descricao : "[NÃO INFORMADO]"
              }}
            </h4> -->
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)" :disabled="submittingForm">
        <v-row>
          <v-col class="pt-0 pb-0" cols="12">
            <ValidationProvider name="Tipo de Aula" rules="required" v-slot="{ errors }">
              <e-label>Tipo de Aula</e-label>
              <e-autocomplete
                :items="$constants.tiposDeAulas"
                :return-object="false"
                :error-messages="errors"
                v-model="aulaSelecionada.tipo_de_aula"
                @change="() => verificaTipoDaAula()"
                label="Selecione uma opção"
                dense
                solo
              />
            </ValidationProvider>
          </v-col>
        </v-row>
        <v-row v-if="mostrarCampos">
          <v-col class="pt-0 pb-0" cols="6">
            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="data"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <e-label>Selecione uma data</e-label>
                <v-text-field
                  v-model="aulaSelecionada.data"
                  persistent-hint
                  :disabled="aulaSelecionada.tipo_de_aula ? false : true"
                  label="Escolha uma data"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  dense
                  solo
                ></v-text-field>
              </template>
              <v-date-picker v-model="data" scrollable :allowed-dates="allowedDates">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modal = false"> Cancel </v-btn>
                <v-btn text color="primary" @click="customEvent(data)"> OK </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>

          <!-- <v-col class="pt-0 pb-0" v-if="aulaSelecionada.tipo_de_aula !== 'Aula Remota'" cols="6">
            <ValidationProvider name="Tipo de Aula" rules="required" v-slot="{ errors }">
              <e-label>Selecione um horário</e-label>
              <e-autocomplete
                :disabled="aulaSelecionada.data ? false : true"
                :items="horariosDoComponente"
                :error-messages="errors"
                label="Selecione uma opção"
                :item-text="(item) => item.descricao"
                v-model="horarioSelecionado"
                return-object
                dense
                @change="() => pesquisaAulas()"
              />
            </ValidationProvider>
          </v-col> -->
        </v-row>

        <v-row v-if="showCamposAbaixo">
          <v-col cols="12">
            <ValidationProvider name="Conteúdo" rules="required" v-slot="{ errors }">
              <e-label>Conteúdo</e-label>
              <v-textarea solo dense v-model="aulaSelecionada.conteudo" :error-messages="errors" />
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider name="Metodologia" rules="required" v-slot="{ errors }">
              <e-label>Metodologia</e-label>
              <v-textarea
                solo
                dense
                v-model="aulaSelecionada.metodologia"
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>
          <v-col>
            <v-btn
              color="primary"
              :disabled="submittingForm"
              :loading="submittingForm"
              type="submit"
              >Enviar Dados</v-btn
            >
            <v-btn v-if="editing" class="ml-3" color="success" @click="dialog.duplicar = true"
              >Duplicar Aula</v-btn
            >
            <v-btn v-if="editing" class="ml-3" color="success" @click="dialog.exportar = true"
              >Exportar Aula</v-btn
            >
          </v-col>
        </v-row>
        <v-row v-if="!aulaSelecionada.tipo_de_aula || !aulaSelecionada.data || !horarioSelecionado">
          <v-col cols="12" v-if="aulaSelecionada.tipo_de_aula !== 'Aula Remota'">
            <v-alert type="warning" border="left"> Por favor, preencha todos os campos! </v-alert>
          </v-col>
        </v-row>
      </form>

      <v-bottom-sheet v-model="aulasEmConflitos" scrollable>
        <v-sheet class="text-center pa-md-8 mx-lg-auto" height="auto">
          <v-btn color="error" dark small @click="aulasEmConflitos = !aulasEmConflitos">
            Fechar
          </v-btn>

          <h2 class="mt-4">Aulas conflitadas</h2>

          <v-simple-table class="mt-4" style="border: 1px solid #e0e0e0">
            <template>
              <thead style="background-color: #e0e0e0">
                <tr>
                  <th class="text-left">#</th>
                  <th class="text-left">Professor</th>
                  <th class="text-left">Situação</th>
                  <th class="text-left">Data/Horario</th>
                  <th class="text-left">Turma</th>
                  <th class="text-left">Disciplina</th>
                </tr>
              </thead>
              <tbody class="text-left">
                <tr v-for="item in aulasConflitadas" :key="item.id">
                  <td>{{ item.id }}</td>
                  <td>
                    {{ item.professor.nome }}
                    <br />
                    <v-chip color="grey" dark x-small>
                      {{ item.turma.franquia.descricao }}
                    </v-chip>
                  </td>
                  <td>{{ item.situacao ? item.situacao : "Aguardando" }}</td>
                  <td>
                    <span>
                      {{ item.data.split("-").reverse().join("/") }}
                    </span>
                    - {{ item.horario.descricao }}
                  </td>
                  <td>{{ item.turma.descricao }}</td>
                  <td>{{ item.disciplina.descricao }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-sheet>
      </v-bottom-sheet>
    </ValidationObserver>

    <e-modal-duplicar-aula
      :submittingForm="submittingForm"
      :dialog="dialog.duplicar"
      :gestaoDeAulas="aulaSelecionada"
      :form="{ ...aulaSelecionada }"
      :horarios="horarios"
      @dialogChange="dialog.duplicar = $event"
    >
    </e-modal-duplicar-aula>
    <e-modal-exportar-aula
      :submittingForm="submittingForm"
      :dialog="dialog.exportar"
      :form="{ ...aulaSelecionada }"
      @dialogChange="dialog.exportar = $event"
      :horarios="horarios"
    >
    </e-modal-exportar-aula>
  </main-template>
</template>

<script>
import ELabel from "../../components/ELabel.vue";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    aula_id: {
      type: Number,
      require: true,
    },
  },
  computed: {
    tipo_de_aula() {
      return this.aulaSelecionada.tipo_de_aula;
    },
  },
  mounted() {
    this.loadData();
    if (this.editing) {
      this.mostrarCampos = true;
      this.showCamposAbaixo = true;
    }
  },
  data() {
    return {
      showCamposAbaixo: true,
      data: null,
      modal: false,
      menu: false,
      aulasEmConflitos: false,
      aulasConflitadas: [],
      mostrarCampos: true,
      submittingForm: false,
      form: null,
      aulaSelecionada: {
        data: null,
      },
      gestaoDeAula: {
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
      },
      aulaDuplicada: {},
      // gestaoDeAulas: null,

      dialog: {
        duplicar: false,
        exportar: false,
      },
      horarios: [],
      horarioSelecionado: {
        descricao: "Escolha um horario",
      },
      horariosSabado: [],
      horariosDoComponente: [],
      diasPermitidosParaCriarAula: [0, 1, 2, 3, 4, 5, 6],
      gestaoDeAulasEletivas: null,
      gestaoDeAulaEletiva: {
        disciplina_id: null,
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
      },
    };
  },
  watch: {
    tipo_de_aula() {
      if (this.aulaSelecionada.tipo_de_aula === "Aula Remota") {
        this.aulaSelecionada.horario_inicial = null;
        this.aulaSelecionada.horario_final = null;
        this.horarioSelecionado = null;
      }
    },
    data(value) {
      const data_old = new Intl.DateTimeFormat("pt-BR", {
        timeZone: "UTC",
      }).format(new Date(value));
      this.aulaSelecionada.data = data_old.replaceAll("/", "/");
    },
  },
  methods: {
    customEvent(data) {
      this.horariosDoComponente =
        new Date(data).getDay() === 5 ? this.horariosSabado : this.horarios;
      this.$refs.dialog.save(data);
    },
    // async pesquisaAulas() {
    //   const data_aula = this.aulaSelecionada.data.replaceAll("/", "-");

    //   /* eslint-disable */
    //   const aula_id = this.$route.params.aula_id;
    //   const horario_id = this.horarioSelecionado.id;
    //   const turma_id = this.gestaoDeAula.turma.id;
    //   if (!data_aula || !this.horarioSelecionado || !this.aulaSelecionada)
    //     return;

    //   const response =
    //     await this.$services.aulasService.pesquisarAulasEmConflitos(
    //       data_aula,
    //       horario_id,
    //       turma_id,
    //       aula_id
    //     );

    //   if (response.data.length === 0) {
    //     this.mostrarCampos = true;
    //     this.showCamposAbaixo = true;
    //     return;
    //   }

    //   this.aulasEmConflitos = true;
    //   this.aulasConflitadas = response.data;
    //   this.mostrarCampos = true;
    //   this.showCamposAbaixo = false;
    // },
    async verificaTipoDaAula() {
      if (this.aulaSelecionada.tipo_de_aula === "Aula Remota" || this.editing) {
        this.getAula();
        this.mostrarCampos = true;
        this.showCamposAbaixo = true;
      } else {
        this.mostrarCampos = true;
        this.showCamposAbaixo = true;
      }
    },
    async submitForm() {
      if (this.horarioSelecionado) {
        // this.aulaSelecionada.horario_inicial = this.horarioSelecionado.inicio;
        // this.aulaSelecionada.horario_final = this.horarioSelecionado.final;
        // this.aulaSelecionada.horario_id = this.horarioSelecionado.id;
        this.submittingForm = true;
      }
      try {
        if (this.editing) {
          this.aulaSelecionada.instrutorDisciplinaMatriculas = parseInt(
            this.$route.params.gestaoDeEletivosId,
            10
          );
          this.aulaSelecionada.data = this.aulaSelecionada.data.split("/").reverse().join("-");
          await this.$services.aulasEletivosService.atualizar(this.aulaSelecionada);
          this.$toast.success("Aula editada com sucesso!");
        } else {
          this.aulaSelecionada.instrutorDisciplinaMatriculas_id = parseInt(
            this.$route.params.gestaoDeEletivosId,
            10
          );

          this.aulaSelecionada.disciplina_id = this.gestaoDeAulaEletiva.disciplina_id;
          // this.aulaSelecionada.turma_id = this.gestaoDeAula.turma_id;
          this.aulaSelecionada.instrutor_id = this.gestaoDeAulaEletiva.instrutor_id;
          this.aulaSelecionada.data = this.aulaSelecionada.data.split("/").reverse().join("-");
          await this.$services.aulasEletivosService.criar(this.aulaSelecionada);
          this.$toast.success("Aula cadastrada com sucesso!");
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
      this.$router.push({
        name: "aulasEletivos",
      });
    },

    async getAula() {
      const { aula_id } = this.$route.params;

      const gestaoDeEletivosId = this.$route.params.gestaoDeEletivosId;
      const response = await this.$services.gestoesDeEletivosService.listarAulasGestao(
        gestaoDeEletivosId
      );
      this.gestaoDeAulaEletiva = response.payload.gestaoDeAulaEletiva;
      const aulaSelecionada = await this.$services.aulasEletivosService.getAula(
        parseInt(aula_id, 10)
      );

      // this.horarioSelecionado = aulaSelecionada.horario;

      // if (this.gestaoDeAula.horarios_ids) {
      //   if (this.gestaoDeAula.horarios_ids.length != 0) {
      //     let data = [];

      //     this.gestaoDeAula.horarios_ids.forEach((idHorario) => {
      //       response.payload.horarios.map((h) => {
      //         if (h.id === idHorario) {
      //           data.push(h);
      //         }
      //       });
      //     });
      //     this.horarios = data;
      //   }
      // } else {
      //   this.horarios = response.payload.horarios;
      // }

      // if (this.gestaoDeAula.relacoesDiasHorarios) {
      //   this.diasPermitidosParaCriarAula =
      //     this.gestaoDeAula.relacoesDiasHorarios.map((g) => g.dia.id);
      //   this.horarios = this.gestaoDeAula.relacoesDiasHorarios.map(
      //     (g) => g.horario
      //   );
      //   this.horariosSabado = this.horarios;
      //   this.horariosSabado = this.horariosSabado.map((h) => {
      //     return {
      //       id: h.id,
      //       turno_id: h.turno_id,
      //       descricao: h.descricao.split(" - ")[0],
      //       final: h.final,
      //       inicio: h.inicio,
      //     };
      //   });
      // }

      return aulaSelecionada;
    },
    async loadData() {
      try {
        this.$loaderService.open("Carregando dados...");
        this.aulaSelecionada = await this.getAula();

        if (this.aulaSelecionada.data) {
          this.aulaSelecionada.data = this.aulaSelecionada.data.split("-").reverse().join("/");
        }
        this.$forceUpdate();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    allowedDates(val) {
      const array = [...this.diasPermitidosParaCriarAula];
      return array.includes(new Date(val).getDay());
    },
  },
};
</script>

<style></style>
